<template>
  <div class="discussion">
    <div class="discussion__header">
      <h2 class="discussion__title">
        <router-link
          class="discussion__link"
          :to="link"
        >
          {{ title }}
        </router-link>
        <v-badge
          v-for="category in categories"
          :key="category"
          class="discussion__category"
          :text="category"
        />
      </h2>
      <span class="discussion__author">Posted by: {{ author }}</span>
      <span
        v-if="date"
        class="discussion__date"
      >{{ date }}</span>
    </div>
    <div class="discussion__body">
      <div class="discussion__content">
        <slot />
      </div>
      <router-link
        class="discussion__comments"
        :to="link"
      >
        <v-icon
          class="discussion__comments-icon"
          type="comments"
        />
        {{ comments }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Badge from "@/atoms/Badge";
import Icon from "@/atoms/Icon";

export default {
  components: {
    "v-badge": Badge,
    "v-icon": Icon
  },
  props: {
    title: {
      type: String,
      default: null,
      required: true
    },
    date: {
      type: String,
      default: null
    },
    author: {
      type: String,
      default: null
    },
    comments: {
      type: Number,
      default: null
    },
    link: {
      type: String,
      default: null,
      required: true
    },
    categories: {
      type: Array,
      default: null,
      required: false
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/shared/shared";

.discussion {
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: solid 1px $zircon;
  color: $kashmir;
  &__header {
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__title {
    margin-bottom: .25rem;
    width: 100%;
  }
  &__link {
    display: inline-block;
    margin-right: 1rem;
    color: $tangaroa;
    &,
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
  &__date {
    color: $stone;
    margin-left: 1rem;
  }
  &__author {
    color: $tangaroa;
  }
  &__category {
    vertical-align: middle;
    margin-right: .25em;
  }
  &__comments {
    margin-left: 2rem;
    white-space: nowrap;
    color: $tangaroa;
    font-size: $font-size-lg;
    &,
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
  &__comments-icon {
    margin-right: 0.25em;
    font-size: 1.5em;
  }
  &__body {
    display: flex;
    align-items: flex-start;
  }
  &__content {
    flex: 1;
  }
}
</style>
